module.exports = {
  "revenueAttributionCard": {
    "name": "Revenue attribution card interactions",
    "class": "interaction",
    "properties": {
      "action": [
        "opened builder",
        "opened modal",
        "changed model",
        "opened drilldown",
        "changed date range"
      ],
      "fromModel": {
        "isOptional": true,
        "type": "string"
      },
      "toModel": {
        "isOptional": true,
        "type": "string"
      },
      "modal": {
        "isOptional": true,
        "type": "string"
      },
      "dateRange": {
        "isOptional": true,
        "type": "string"
      },
      "isDateRangeSelectedSupported": {
        "isOptional": true,
        "type": "boolean"
      }
    },
    "namespace": "reporting"
  }
};